export default __webpack_public_path__ + "static/media/5.31c6e92b.png";